import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import {
  railWidthCollapsed,
  railTransitionDuration,
  railTransitionEasing,
} from '@/theme/customTheme';
import { fontScale } from '@/theme';

export const useNavRailItemStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    minHeight: '2.5rem',
    color: tokens.colorNeutralForeground1,
    textDecorationLine: 'none',
    ...shorthands.padding(tokens.spacingVerticalXS, '0'),
    ...shorthands.gap('0'),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    cursor: 'pointer',
    boxSizing: 'border-box',
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
    ':focus-visible': {
      outlineStyle: 'solid',
      outlineWidth: '2px',
      outlineColor: tokens.colorStrokeFocus2,
      outlineOffset: '-2px',
    },
  },
  rootActive: {
    color: tokens.colorBrandForeground1,
    fontWeight: tokens.fontWeightSemibold,
  },
  iconColumn: {
    flexShrink: 0,
    width: railWidthCollapsed,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  label: {
    flexGrow: 1,
    whiteSpace: 'nowrap',
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: fontScale.body,
    lineHeight: tokens.lineHeightBase300,
    paddingRight: tokens.spacingHorizontalS,
    transitionProperty: 'opacity',
    transitionDuration: railTransitionDuration,
    transitionTimingFunction: railTransitionEasing,
  },
  labelHidden: {
    opacity: 0,
    pointerEvents: 'none',
  },
});
